<template>
    <div>
        <h2> {{fieldName}} Options </h2>
        <div class="form-group">
            <p v-for="option in options">
                <input type="text" v-model="option.value" :name="setInputName()" class="form-control">
            </p>
        </div>
        <div class="form-group">
            <button @click.prevent="addInput"> Add New Option</button>
        </div>

    </div>
</template>

<script>
    export default{
        name:'SetOptionsFilter',
        props : ['initialOptions','fieldName','fieldKey','selectType'],
        data(){
            return {
               csrfToken : Laravel.csrfToken,
               appUrl : Laravel.appUrl,
               options:[]
            }
        },
        methods:{
            addOption(){

            },

            removeOption(addedOptionLabel){

            },
            showOptions(){

            },

            initializeSelectedFreeTags(data){
            },
            setInputName(){
                return this.fieldKey + '[]';
            },

            addInput(){
                 this.options.push({ value: '' });
            },
             selectify(prop, options, value, label ){
                // filters data into label-value associations
                // for selects, checkboxes, radios
                if( typeof options === 'object'){
                    for (const key of Object.keys(options)) {
                         prop.push({
                                 label: options[key][label],
                                 value: options[key][value]
                         })
                     }
                }
                if( typeof options === 'array'){
                   options.map(function(item) {
                        prop.push({
                            label: item[label],
                            value: item[value]
                        })
                    });
                }
            },

        },
         computed: {
            // format the Object array of 'aaa_bb_cc':'aaa bb cc'
            // into key: 'aaa_bb_cc' and value: 'aaa bb cc' array
            setInitialSelectify: function(){
                   this.options=[];


                   if( typeof this.initialOptions === 'object'){

                        for (const key of Object.keys(this.initialOptions)) {
                            this.options.push({
                                 key: key,
                                 value: this.initialOptions[key]
                            })
                        }
                    }

            }
        },
         created(){

                this.setInitialSelectify;
               console.log('this options', this.options);

             if (typeof App != 'undefined') {

            }
        }
    }






</script>

